(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wig-care-materials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class WigCareMaterials {
      constructor(section) {
        this.section = section;
        this.slider = section.querySelector('[data-care-slider]');
        
        if (!this.slider) return;
        
        this.cards = Array.from(this.slider.querySelectorAll('[data-care-card]'));
        this.prevBtn = section.querySelector('[data-care-prev]');
        this.nextBtn = section.querySelector('[data-care-next]');

        if (this.cards.length <= 1) return;

        this.initLoop();
      }

      initLoop() {
        if (window.innerWidth > 1100) return;

        // Perform programmatic clones inside browser runtime memory ONLY for mobile screen viewports
        this.cards.forEach(card => {
          const cloneBefore = card.cloneNode(true);
          const cloneAfter = card.cloneNode(true);
          cloneBefore.classList.add('is-clone');
          cloneAfter.classList.add('is-clone');
          this.slider.insertBefore(cloneBefore, this.slider.firstChild);
          this.slider.appendChild(cloneAfter);
        });

        this.extendedCards = Array.from(this.slider.children);
        this.originalCount = this.cards.length;
        this.currentIndex = this.originalCount;
        
        setTimeout(() => this.updatePosition(false), 50);

        if (this.nextBtn && this.prevBtn) {
          this.nextBtn.addEventListener('click', () => this.move(1));
          this.prevBtn.addEventListener('click', () => this.move(-1));
        }

        this.slider.addEventListener('scroll', () => this.checkBoundary(), { passive: true });
      }

      move(direction) {
        if (this.isMoving) return;
        this.isMoving = true;

        this.currentIndex += direction;
        this.updatePosition(true);

        setTimeout(() => {
          this.isMoving = false;
        }, 400);
      }

      updatePosition(smooth) {
        if (!this.extendedCards || !this.extendedCards[this.currentIndex]) return;
        
        const cardWidth = this.extendedCards[this.currentIndex].getBoundingClientRect().width;
        const gap = 12; 
        const targetScroll = this.currentIndex * (cardWidth + gap);

        this.slider.scrollTo({
          left: targetScroll,
          behavior: smooth ? 'smooth' : 'auto'
        });
      }

      checkBoundary() {
        if (window.innerWidth > 1100 || !this.extendedCards) return;
        
        const cardWidth = this.extendedCards[0].getBoundingClientRect().width;
        const gap = 12;
        const stepWidth = cardWidth + gap;
        const currentScroll = this.slider.scrollLeft;

        if (currentScroll <= (this.originalCount - 1) * stepWidth) {
          this.slider.scrollLeft += this.originalCount * stepWidth;
          this.currentIndex += this.originalCount;
        } 
        else if (currentScroll >= (this.originalCount * 2 + 1) * stepWidth) {
          this.slider.scrollLeft -= this.originalCount * stepWidth;
          this.currentIndex -= this.originalCount;
        }
      }
    }

    function initWigCareMaterialsSections(root = document) {
      root.querySelectorAll('[data-wig-care-materials]:not([data-wig-care-ready])').forEach((section) => {
        section.setAttribute('data-wig-care-ready', 'true');
        new WigCareMaterials(section);
      });
    }

    document.addEventListener('DOMContentLoaded', () => initWigCareMaterialsSections());
    document.addEventListener('shopify:section:load', (event) => initWigCareMaterialsSections(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wig-experience-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class WigExperience {
      constructor(section) {
        this.section = section;
        this.grid = section.querySelector('[data-experience-grid]');
        this.prevBtn = section.querySelector('[data-experience-prev]');
        this.nextBtn = section.querySelector('[data-experience-next]');

        if (!this.grid || !this.prevBtn || !this.nextBtn) return;

        this.initNav();
      }

      initNav() {
        // Click Next arrow
        this.nextBtn.addEventListener('click', () => {
          const cardWidth = this.grid.firstElementChild.getBoundingClientRect().width;
          const gap = 12; 
          this.grid.scrollBy({ left: cardWidth + gap, behavior: 'smooth' });
        });

        // Click Prev arrow
        this.prevBtn.addEventListener('click', () => {
          const cardWidth = this.grid.firstElementChild.getBoundingClientRect().width;
          const gap = 12;
          this.grid.scrollBy({ left: -(cardWidth + gap), behavior: 'smooth' });
        });

        // Listen to carousel scroll event to update arrow button states (enabled/disabled)
        this.grid.addEventListener('scroll', () => this.updateButtons(), { passive: true });
        window.addEventListener('resize', () => this.updateButtons(), { passive: true });
        
        this.updateButtons();
      }

      updateButtons() {
        const scrollLeft = this.grid.scrollLeft;
        const maxScrollLeft = this.grid.scrollWidth - this.grid.clientWidth;

        // Disable left arrow if at the very beginning
        this.prevBtn.disabled = scrollLeft <= 4;
        
        // Disable right arrow if at the very end
        this.nextBtn.disabled = scrollLeft >= maxScrollLeft - 4;
      }
    }

    function initWigExperiences(root = document) {
      root.querySelectorAll('[data-wig-experience]:not([data-wig-experience-ready])').forEach((section) => {
        section.setAttribute('data-wig-experience-ready', 'true');
        new WigExperience(section);
      });
    }

    document.addEventListener('DOMContentLoaded', () => {
      initWigExperiences();
    });

    document.addEventListener('shopify:section:load', (event) => {
      initWigExperiences(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wig-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class WigHeader {
      constructor(header) {
        this.header = header;
        this.openButton = header.querySelector('[data-wig-menu-open]');
        this.closeButton = header.querySelector('[data-wig-menu-close]');
        this.overlay = header.querySelector('[data-wig-menu-overlay]');

        this.handleScroll = this.handleScroll.bind(this);

        this.openButton?.addEventListener('click', () => this.open());
        this.closeButton?.addEventListener('click', () => this.close());
        this.overlay?.addEventListener('click', () => this.close());

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.close();
        });

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        this.handleScroll();
      }

      handleScroll() {
        this.header.classList.toggle('is-scrolled', window.scrollY > 12);
      }

      open() {
        this.header.classList.add('is-open');
        document.body.classList.add('wig-menu-open');
      }

      close() {
        this.header.classList.remove('is-open');
        document.body.classList.remove('wig-menu-open');
      }
    }

    function initWigHeaders(root = document) {
      root.querySelectorAll('[data-wig-header]:not([data-wig-header-ready])').forEach((header) => {
        header.setAttribute('data-wig-header-ready', 'true');
        new WigHeader(header);
      });
    }

    document.addEventListener('DOMContentLoaded', () => {
      initWigHeaders();
    });

    document.addEventListener('shopify:section:load', (event) => {
      initWigHeaders(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wig-hero"] && !Shopify.designMode) return;
  try {
    
  class WigHero {
    constructor(hero) {
      this.hero = hero;
      this.tabs = Array.from(hero.querySelectorAll('[data-wig-hero-tab]'));
      this.slides = Array.from(hero.querySelectorAll('[data-wig-hero-media]'));
      this.viewButtons = Array.from(hero.querySelectorAll('[data-wig-hero-view]'));
      this.lookTitle = hero.querySelector('[data-wig-hero-look-title]');
      this.lookText = hero.querySelector('[data-wig-hero-look-text]');
      this.currentIndex = 0;
      this.currentView = 'front';
      this.autoplayTimer = null;
      this.autoplay = hero.dataset.autoplay === 'true';
      this.interval = Number.parseInt(hero.dataset.interval, 10) || 6000;

      if (!this.slides.length) return;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          this.activate(index);
          this.restartAutoplay();
        });
      });

      this.viewButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.currentView = button.dataset.wigHeroView || 'front';
          this.updateView();
        });
      });

      this.hero.addEventListener('mouseenter', () => this.stopAutoplay());
      this.hero.addEventListener('mouseleave', () => this.startAutoplay());

      this.activate(0);
      this.updateView();
      this.startAutoplay();
    }

    activate(index) {
      this.currentIndex = index;

      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });

      const activeTab = this.tabs[index];

      if (activeTab && this.lookTitle) {
        this.lookTitle.textContent = activeTab.dataset.lookTitle || 'Signature Wig Look';
      }

      if (activeTab && this.lookText) {
        this.lookText.textContent =
          activeTab.dataset.lookText ||
          'Switch between wig styles and see how color, length, and texture change the whole mood.';
      }

      this.updateView();
    }

    updateView() {
      this.viewButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.wigHeroView === this.currentView);
      });

      this.slides.forEach((slide) => {
        slide.querySelectorAll('[data-wig-hero-image]').forEach((image) => {
          image.classList.toggle('is-active', image.dataset.wigHeroImage === this.currentView);
        });
      });
    }

    next() {
      if (!this.tabs.length) return;

      const nextIndex = (this.currentIndex + 1) % this.tabs.length;
      this.activate(nextIndex);
    }

    startAutoplay() {
      if (!this.autoplay || this.tabs.length < 2 || this.autoplayTimer) return;

      this.autoplayTimer = window.setInterval(() => {
        this.next();
      }, this.interval);
    }

    stopAutoplay() {
      if (!this.autoplayTimer) return;

      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  function initWigHeroes(root = document) {
    root.querySelectorAll('[data-wig-hero]:not([data-wig-hero-ready])').forEach((hero) => {
      hero.setAttribute('data-wig-hero-ready', 'true');
      new WigHero(hero);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initWigHeroes();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initWigHeroes(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wig-how-it-works"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class WigProductMarquee {
      constructor(section) {
        this.section = section;
        this.viewport = section.querySelector('[data-row-viewport]');
        this.track = section.querySelector('[data-row-track]');
        this.cards = Array.from(section.querySelectorAll('[data-product-card]'));

        if (!this.viewport || !this.track || this.cards.length < 2) return;

        // Speed config values parsed directly from CSS custom property definitions
        const speedValue = parseFloat(getComputedStyle(section).getPropertyValue('--row-speed')) || 80;
        this.speed = (this.cards.length * 180) / speedValue / 60; // Pixels per frame metric logic

        this.currentX = 0;
        this.isDragging = false;
        this.startX = 0;
        this.dragX = 0;
        this.animationFrameId = null;

        this.init();
      }

      init() {
        // Run ticker loop setup logic
        this.startTicker();

        // Desktop interaction bounds (pause scrolling movement on hover)
        this.section.addEventListener('mouseenter', () => this.isHovered = true);
        this.section.addEventListener('mouseleave', () => {
          this.isHovered = false;
          if (this.isDragging) this.endDrag();
        });

        // Universal drag & manual touch-swipe scroll listeners
        this.track.addEventListener('mousedown', (e) => this.startDrag(e.clientX));
        window.addEventListener('mousemove', (e) => this.handleDrag(e.clientX));
        window.addEventListener('mouseup', () => this.endDrag());

        this.track.addEventListener('touchstart', (e) => this.startDrag(e.touches[0].clientX), { passive: true });
        window.addEventListener('touchmove', (e) => this.handleDrag(e.touches[0].clientX), { passive: false });
        window.addEventListener('touchend', () => this.endDrag());

        // Stop anchor tags from firing routing events immediately while scrolling actively
        this.track.querySelectorAll('a').forEach(anchor => {
          anchor.addEventListener('click', (e) => {
            if (Math.abs(this.dragX) > 6) e.preventDefault();
          });
        });
      }

      startTicker() {
        const loop = () => {
          if (!this.isDragging) {
            // Apply background translation over frames unless active drag interaction override occurs
            const currentSpeed = this.isHovered && window.innerWidth > 749 ? this.speed * 0.15 : this.speed;
            this.currentX -= currentSpeed;
            this.handleLoopBoundary();
            this.track.style.transform = `translateX(${this.currentX}px)`;
          }
          this.animationFrameId = requestAnimationFrame(loop);
        };
        this.animationFrameId = requestAnimationFrame(loop);
      }

      startDrag(clientX) {
        this.isDragging = true;
        this.startX = clientX;
        this.dragX = 0;
        this.track.style.transition = 'none';
      }

      handleDrag(clientX) {
        if (!this.isDragging) return;
        
        this.dragX = clientX - this.startX;
        this.currentX += this.dragX;
        this.startX = clientX;

        this.handleLoopBoundary();
        this.track.style.transform = `translateX(${this.currentX}px)`;
      }

      endDrag() {
        if (!this.isDragging) return;
        this.isDragging = false;
      }

      handleLoopBoundary() {
        const halfWidth = this.track.scrollWidth / 2;
        
        // Endless wrapping recalculation anchors for dual symmetric layout loops
        if (this.currentX <= -halfWidth) {
          this.currentX += halfWidth;
        } else if (this.currentX > 0) {
          this.currentX -= halfWidth;
        }
      }
    }

    function initWigProductRows(root = document) {
      root.querySelectorAll('[data-product-row-section]:not([data-marquee-ready])').forEach((section) => {
        section.setAttribute('data-marquee-ready', 'true');
        new WigProductMarquee(section);
      });
    }

    document.addEventListener('DOMContentLoaded', () => initWigProductRows());
    document.addEventListener('shopify:section:load', (e) => initWigProductRows(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wig-look-switcher"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class WigLookSwitcher {
      constructor(section) {
        this.section = section;
        this.cards = Array.from(section.querySelectorAll('[data-look-card]'));
        this.slides = Array.from(section.querySelectorAll('[data-look-slide]'));
        this.currentIndex = 0;

        this.title = section.querySelector('[data-look-title]');
        this.text = section.querySelector('[data-look-text]');
        this.mood = section.querySelector('[data-look-mood]');
        this.length = section.querySelector('[data-look-length]');
        this.texture = section.querySelector('[data-look-texture]');
        this.productLink = section.querySelector('[data-look-product-link]');

        this.cards.forEach((card, index) => {
          // Keep hover for desktop
          card.addEventListener('mouseenter', () => {
            if (window.innerWidth > 749) this.activateLook(index);
          });
          
          card.addEventListener('focus', () => this.activateLook(index));
          
          // Click/tap handler (for both mobile and PC)
          card.addEventListener('click', (e) => {
            if (this.currentIndex !== index) {
              // If the card is not active — activate it and block immediate product page navigation
              e.preventDefault();
              this.activateLook(index);
              
              // Smooth scroll to the selected card in the mobile carousel
              card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            }
            // If the card is already active — the click works normally as a product link
          });
        });

        this.activateLook(0);
      }

      activateLook(index) {
        this.currentIndex = index;

        this.cards.forEach((card, cardIndex) => {
          card.classList.toggle('is-active', cardIndex === index);
        });

        this.slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === index);
        });

        const activeCard = this.cards[index];

        if (!activeCard) return;

        if (this.title) this.title.textContent = activeCard.dataset.title || 'Royal Merlot';

        if (this.text) {
          this.text.textContent =
            activeCard.dataset.text ||
            'A premium wig style with expressive color and soft movement.';
        }

        if (this.mood) this.mood.textContent = activeCard.dataset.mood || 'Premium mood';
        if (this.length) this.length.textContent = activeCard.dataset.length || 'Long';
        if (this.texture) this.texture.textContent = activeCard.dataset.texture || 'Soft wave';

        if (this.productLink && activeCard.dataset.productLink) {
          this.productLink.setAttribute('href', activeCard.dataset.productLink);
        }
      }
    }

    function initWigLookSwitcher(root = document) {
      root.querySelectorAll('[data-wig-look-switcher]:not([data-wig-look-ready])').forEach((section) => {
        section.setAttribute('data-wig-look-ready', 'true');
        new WigLookSwitcher(section);
      });
    }

    document.addEventListener('DOMContentLoaded', () => {
      initWigLookSwitcher();
    });

    document.addEventListener('shopify:section:load', (event) => {
      initWigLookSwitcher(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wig-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class WigPremiumHero {
      constructor(section) {
        this.section = section;
        this.slides = Array.from(section.querySelectorAll('[data-hero-slide]'));
        this.dots = Array.from(section.querySelectorAll('[data-hero-dot]'));
        this.autoplay = section.dataset.autoplay === 'true';
        this.interval = parseInt(section.dataset.interval, 10) || 5000;
        this.current = 0;
        this.timer = null;

        if (!this.slides.length) return;

        this.bindEvents();
        this.start();
      }

      bindEvents() {
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const index = parseInt(dot.dataset.index, 10);
            this.goTo(index);
            this.restart();
          });
        });

        this.section.addEventListener('mouseenter', () => this.stop());
        this.section.addEventListener('mouseleave', () => this.start());
      }

      goTo(index) {
        this.current = index;

        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
        });

        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
        });
      }

      next() {
        const nextIndex = (this.current + 1) % this.slides.length;
        this.goTo(nextIndex);
      }

      start() {
        if (!this.autoplay || this.slides.length < 2) return;
        this.stop();
        this.timer = setInterval(() => this.next(), this.interval);
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }
    }

    function initWigPremiumHeroes(root = document) {
      root.querySelectorAll('[data-wig-premium-hero]:not([data-wig-premium-hero-ready])').forEach((section) => {
        section.setAttribute('data-wig-premium-hero-ready', 'true');
        new WigPremiumHero(section);
      });
    }

    document.addEventListener('DOMContentLoaded', () => {
      initWigPremiumHeroes();
    });

    document.addEventListener('shopify:section:load', (event) => {
      initWigPremiumHeroes(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wig-style-categories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class WigPremiumExperience {
      constructor(section) {
        this.section = section;
        this.features = Array.from(section.querySelectorAll('[data-premium-feature]'));
        this.slides = Array.from(section.querySelectorAll('[data-premium-slide]'));
        this.label = section.querySelector('[data-premium-label]');
        this.title = section.querySelector('[data-premium-title]');
        this.text = section.querySelector('[data-premium-text]');

        if (!this.features.length || !this.slides.length) return;

        this.features.forEach((feature, index) => {
          feature.addEventListener('click', () => this.activate(index));
          feature.addEventListener('mouseenter', () => this.activate(index));
        });

        this.activate(0);
      }

      activate(index) {
        this.features.forEach((feature, featureIndex) => {
          feature.classList.toggle('is-active', featureIndex === index);
        });

        this.slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === index);
        });

        const activeFeature = this.features[index];

        if (!activeFeature) return;

        if (this.label) {
          this.label.textContent = activeFeature.dataset.label || 'Premium detail';
        }

        if (this.title) {
          this.title.textContent = activeFeature.dataset.title || 'Realistic texture';
        }

        if (this.text) {
          this.text.textContent =
            activeFeature.dataset.text ||
            'Soft movement, natural shine, and a realistic finish designed to help every wig look elevated and wearable.';
        }
      }
    }

    function initWigPremiumExperience(root = document) {
      root.querySelectorAll('[data-wig-premium-experience]:not([data-wig-premium-ready])').forEach((section) => {
        section.setAttribute('data-wig-premium-ready', 'true');
        new WigPremiumExperience(section);
      });
    }

    document.addEventListener('DOMContentLoaded', () => {
      initWigPremiumExperience();
    });

    document.addEventListener('shopify:section:load', (event) => {
      initWigPremiumExperience(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
